const circle = "_circle_g5mci_4";
const styles = {
  "progress-indeterminate": "_progress-indeterminate_g5mci_1",
  "indeterminate-animation": "_indeterminate-animation_g5mci_1",
  circle,
  "circle-indeterminate-animation": "_circle-indeterminate-animation_g5mci_1",
  "progress-determinate": "_progress-determinate_g5mci_10"
};
export {
  circle,
  styles as default
};
//# sourceMappingURL=CircularProgress.module.scss.js.map
